/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueCodeModel } from '../../models/key-value-code-model';

export interface MasterDataProfessionLookupByValueGet$Params {
  value?: string;
  maxResults?: number;
  countryISOCode?: string;
  languageRegion?: string;
}

export function masterDataProfessionLookupByValueGet(http: HttpClient, rootUrl: string, params?: MasterDataProfessionLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataProfessionLookupByValueGet.PATH, 'get');
  if (params) {
    rb.query('value', params.value, {});
    rb.query('maxResults', params.maxResults, {});
    rb.query('countryISOCode', params.countryISOCode, {});
    rb.query('languageRegion', params.languageRegion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<KeyValueCodeModel>>;
    })
  );
}

masterDataProfessionLookupByValueGet.PATH = '/MasterData/ProfessionLookupByValue';
